import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { Dropdown } from '@kl/components-v6';
import { LocalizedText } from 'shared/ui/localized-text';
import { useLocalesDropdown } from '../model/useLocalesDropdown';
import { StyledTriggerElementContainer } from './styled';

interface ChangeLanguageProps {
    trigger: 'click' | 'hover' | 'contextMenu';
}

export const ChangeLanguage: FC<PropsWithChildren<ChangeLanguageProps>> = ({
    children,
    trigger,
}) => {
    const dropdown = useLocalesDropdown();

    return (
        <Dropdown
            placement="topRight"
            trigger={[trigger]}
            overlay={
                <Dropdown.Menu>
                    <Dropdown.GroupTitle>
                        <LocalizedText localizationKey="ChangeLanguage" type="BTM2" />
                    </Dropdown.GroupTitle>
                    {dropdown.map(({ children, onClick, componentsBefore }, index) => (
                        <Dropdown.MenuItem
                            key={index}
                            onClick={onClick}
                            type="group"
                            componentsBefore={componentsBefore}
                        >
                            {children}
                        </Dropdown.MenuItem>
                    ))}
                </Dropdown.Menu>
            }
        >
            <StyledTriggerElementContainer>{children}</StyledTriggerElementContainer>
        </Dropdown>
    );
};
